/** @format */

import React from "react";
import { Typography, Autocomplete, TextField } from "@mui/material";
import "./Header.css";

const Header = ({ locations, location, setLocation, gpsData }) => {
  if (!locations)
    return (
      <header className="header">
        <Typography variant="h5">Loading...</Typography>
      </header>
    );
  return (
    <div className="header">
      <div className="header-content">
        <div className="header-left">
          <div className="location-info">
            <span className="location-icon">📍</span>
            <span>Tamil Nadu, India</span>
          </div>
        </div>
        <div className="header-right">
          <div className="search-container">  
              <Autocomplete
                options={locations.map((loc) => loc.label)}
                value={location}
                onChange={(event, newValue) =>
                  setLocation(newValue || "Thoothukudi")
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Search District/Town/Village"
                    variant="outlined"
                  />
                )}
                sx={{ width: "300px" }}
              />
            <Typography variant="body2" sx={{ mt: 1 }}>
              GPS: Lat {gpsData.latitude.toFixed(4)}, Lon{" "}
              {gpsData.longitude.toFixed(4)}
            </Typography>
            <button className="search-button">🔍</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
